import { handleErrorDialog, showConfirmDialog, showCustomDialog } from '@juvare/common-web-ui/DialogHelper';
import { showAlertSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import { launchBulkAction } from '@juvare/platform-sdk-react/ui/features/bulk-actions';
import { useFunctionClient } from '@juvare/platform-sdk-react/ui/hooks';
import { Typography } from '@mui/material';
import Alert from '@mui/material/Alert';
import isEqual from 'lodash/isEqual';
import React from 'react';
import { updateFilePermissionsBulkActionType, } from '../../backend/features/file-manager';
// eslint-disable-next-line no-restricted-imports
import { PermissionsDialog } from '../features/file-manager/components/PermissionsDialog';
import { useDocumentLibraryTranslations } from './useDocumentLibraryTranslations';
export const useManagePermission = () => {
    const { t } = useDocumentLibraryTranslations();
    const functionClient = useFunctionClient();
    const showManagePermissionDialog = (file, onUpdatePermissionsSuccess) => {
        const initialPermissions = file.data.permissions || {};
        const fileEntityType = file.columns.directory ? t('common.folder') : t('common.file');
        showCustomDialog({
            content: (close) => (React.createElement(PermissionsDialog, { permissions: initialPermissions, ownerId: file.columns.ownerId, onSubmit: (permissions) => {
                    // close modal if no changes
                    if (isEqual(permissions, initialPermissions)) {
                        close();
                        return;
                    }
                    showConfirmDialog({
                        title: t('permissionsDialog.title'),
                        content: (React.createElement(Alert, { severity: 'error', color: 'warning' },
                            React.createElement(Typography, null, t('permissionsDialog.content')))),
                        confirmLabel: t('permissionsDialog.actions.continue'),
                        onConfirm: () => {
                            functionClient
                                .executeFunction({
                                functionName: 'validatePermissionsCount',
                                params: {
                                    fileId: file.id,
                                    permissions: permissions,
                                },
                            })
                                .then(() => {
                                launchBulkAction({
                                    type: updateFilePermissionsBulkActionType,
                                    title: t('permissionsDialog.bulkActions.updatePermissions.title'),
                                    params: {
                                        fileId: file.id,
                                        permissions: permissions,
                                    },
                                    onClose: () => close(() => {
                                        onUpdatePermissionsSuccess();
                                        showAlertSnackbar({
                                            horizontalPosition: 'center',
                                            type: 'success',
                                            verticalPosition: 'bottom',
                                            autoHideDuration: 2000,
                                            message: t('permissionsDialog.accessSavedSnackbar', {
                                                fileEntityType,
                                            }),
                                        });
                                    }),
                                });
                            })
                                .catch(handleErrorDialog);
                        },
                    });
                }, onCancel: close })),
        });
    };
    return {
        showManagePermissionDialog,
    };
};
